<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.integralActivityTargetList.push"
  >
    <v-column-time/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>

    <el-table-column label="所属活动" prop="title"/>

    <el-table-column label="目标节数">
      <template v-slot="{ row }">
        {{ row.signed_count | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="积分奖励">
      <template v-slot="{ row }">
        {{ row.integral | toYuan }}
      </template>
    </el-table-column>

    <el-table-column label="实物奖励" prop="entity_name"/>

    <el-table-column label="实物奖励总库存" prop="entity_count"/>

    <el-table-column label="实物奖励封面">
      <template v-slot="{ row }">
        <v-img :value="row.entity_cover" class="cover"/>
      </template>
    </el-table-column>

    <el-table-column label="开始时间" prop="summary">
      <template v-slot="{ row }">
        {{ row.start_time | timeToYmdHi }}
      </template>
    </el-table-column>
    <el-table-column label="结束时间" prop="summary">
      <template v-slot="{ row }">
        {{ row.end_time | timeToYmdHi }}
      </template>
    </el-table-column>

    <el-table-column label="操作" width="280">
      <template v-slot="{ row }">

        <v-list-button v-if="isAdministrator" :to="RouteConfig.integralActivityTargetEdit.to(row.id)"/>

        <v-list-button icon="signed-in" name="实物领取" size="large" :to="RouteConfig.integralActivityTargetEntityReceiveManage.to(row.id)"/>

        <v-popover v-if="isAdministrator">
          <v-popover-item
            icon="bin"
            name="删除目标"
            @click="handleDelete(row.id, row.update_time)"
            :is-loading="isDeleting[row.id]"
            message="确定要删除此目标吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`integral-activity-target-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属活动</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>目标节数</span>
              <span>{{ v.signed_count | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>积分奖励</span>
              <span>{{ v.integral | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>实物奖励</span>
              <span>{{ v.entity_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>实物奖励总库存</span>
              <span>{{ v.entity_count }}</span>
            </div>
            <div class="list-item-detail">
              <span>实物奖励封面</span>
              <v-img :value="v.entity_cover" class="cover"/>
            </div>
            <div class="list-item-detail">
              <span>开始时间</span>
              <span>{{ v.start_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>结束时间</span>
              <span>{{ v.end_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button v-if="isAdministrator" :to="RouteConfig.integralActivityTargetEdit.to(v.id)"/>
              <v-list-button icon="signed-in" name="实物领取" size="large" :to="RouteConfig.integralActivityTargetEntityReceiveManage.to(v.id)"/>
              <v-popover v-if="isAdministrator">
                <v-popover-item
                  icon="bin"
                  name="删除目标"
                  @click="handleDelete(v.id, v.update_time)"
                  :is-loading="isDeleting[v.id]"
                  message="确定要删除此目标吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/integral-activity-target';

export default {
  name: RouteConfig.integralActivityTargetList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id, update_time) {
      if (!id) return this.$message.warning('缺少活动 ID，无法删除该活动！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>

<style src="./index.css" scoped/>
